import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M21.577 2.077c-.566-1.436-2.588-1.436-3.154 0l-3.695 9.39a1.696 1.696 0 0 1-1.434 1.072l-9.739.825c-1.479.126-2.095 1.966-.992 2.965l7.542 6.829a1.71 1.71 0 0 1 .52 1.643L8.341 34.913c-.336 1.488 1.293 2.636 2.57 1.811l8.172-5.275a1.688 1.688 0 0 1 1.832 0l8.172 5.275c1.277.825 2.906-.323 2.57-1.81L29.376 24.8a1.71 1.71 0 0 1 .518-1.643l7.543-6.829c1.103-.999.487-2.84-.992-2.965l-9.739-.825a1.696 1.696 0 0 1-1.434-1.071l-3.695-9.39Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var PictogramActionStarOn40 = createIcon(IconComponent);